function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogs = function SvgLogs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M84.428 146.676H71.399a.39.39 0 0 0-.391.39v15.184a.39.39 0 0 0 .391.391h13.029a.39.39 0 0 0 .391-.389v-15.184a.39.39 0 0 0-.391-.392zm-.39 15.184H71.789v-14.4h12.249v14.405zm-10.067-1.811h7.853a.39.39 0 1 0 0-.779h-7.853a.39.39 0 0 0 0 .78z",
    "data-name": "header-icon-work order",
    style: {
      fillRule: "evenodd",
      fill: "currentColor"
    },
    transform: "translate(-67.008 -143.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4460",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.546 409.714a.37.37 0 0 1-.268-.626l1.21-1.269-1.21-1.269a.37.37 0 1 1 .536-.512l1.454 1.525a.37.37 0 0 1 0 .511l-1.454 1.525a.368.368 0 0 1-.268.115z",
    "data-name": "Path 11653",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-716.606 -399.017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.582 409.887a.507.507 0 0 1-.367-.857l1.12-1.175-1.12-1.175a.507.507 0 0 1 .734-.7l1.454 1.525a.506.506 0 0 1 0 .7l-1.454 1.525a.5.5 0 0 1-.367.157z",
    "data-name": "Path 11653 - Outline",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-716.642 -399.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.036 409.888a.507.507 0 0 0 .367-.857l-1.119-1.175 1.119-1.175a.507.507 0 0 0-.367-.857.5.5 0 0 0-.367.157l-1.453 1.525a.506.506 0 0 0 0 .7l1.453 1.525a.5.5 0 0 0 .367.157z",
    "data-name": "Path 11653 - Outline",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-723.978 -399.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.149 393.821a.52.52 0 0 1-.164-.027.508.508 0 0 1-.315-.645l1.284-3.711a.507.507 0 0 1 .958.331l-1.284 3.711a.508.508 0 0 1-.479.341z",
    "data-name": "Path 11655 - Outline",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-538.791 -382.657)"
  })));
};
export default SvgLogs;